import React, { useEffect, useState } from "react";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "./Table"; // new

function TableData() {
 
  const data = [
    {
        name: "Steve Smith",
        country: "USA",
        purchase: "23",
    },
    {
        name: "Steve Smith",
        country: "Canada",
        purchase: "25",
    },
    {
        name: "Steve Smith",
        country: "USA",
        purchase: "27",
    },
    {
        name: "Steve Smith",
        country: "USA",
        purchase: "22",
    },
  ]

  const columns = React.useMemo(
    () => [
      {
        Header: "Client Name",
        accessor: "name",
      },
      {
        Header: "Country",
        accessor: "country",
      },
     
      {
        Header: "Total Purchase",
        accessor: "purchase",
      },
    
    ],
    []
  );

  return (
    <div className="mb-4 h-fit">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-1">
          <Table
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default TableData;
